// extracted by mini-css-extract-plugin
export var blackLine = "Guarantee-module--blackLine--u3MZY";
export var button = "Guarantee-module--button--LI56g";
export var description = "Guarantee-module--description--S1hTh";
export var displayDesktop = "Guarantee-module--displayDesktop--zjXHC";
export var displayDesktopFlex = "Guarantee-module--displayDesktopFlex--6bFAh";
export var displayMobile = "Guarantee-module--displayMobile--sCV1U";
export var elipse = "Guarantee-module--elipse--lfmv+";
export var geyCard = "Guarantee-module--geyCard--rAG15";
export var item = "Guarantee-module--item--zX3Ys";
export var logoPro = "Guarantee-module--logoPro--4FiAt";
export var menu = "Guarantee-module--menu--Djms+";
export var menuItems = "Guarantee-module--menuItems--7zbHV";
export var overflow = "Guarantee-module--overflow--W4DW2";
export var paginationWrapper = "Guarantee-module--paginationWrapper---+WZD";
export var slideDiv = "Guarantee-module--slideDiv--L3rWd";
export var swipe = "Guarantee-module--swipe--SklkL";
export var title = "Guarantee-module--title--M+7Ou";
export var wrapper = "Guarantee-module--wrapper--6h6oT";
export var yellowLine = "Guarantee-module--yellowLine--864DP";
export var yellowRight = "Guarantee-module--yellowRight--uv6dT";